
























































































































































































































import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import SectionWrappe from "@/components/section/SectionWrappe.vue";
import Tag from "@/components/tag/tag.vue";
import * as types from "@/store/constants/types";
import { isIos } from "@/utils/lodash";
import GeneralUtilsHelper from "@/utils/generalUtils";
import { StringifyOptions } from "querystring";
import numUtils from "@/utils/numUtils";
import VipOfferUtils from "@/utils/vipOfferUtils";
import * as Localized from "@/utils/localizedUtil.ts";

@Component({
  components: {
    // [Tabbar.name]: Tabbar,
    SectionWrappe,
    Tag
  }
})
export default class PaymentSelect extends Vue {
  @Action(types.DIALOG_SHOW) private dialogShow: any;
  @Getter(types.GETTER_INFO_BY_OFFER_DATA) private infoByOffer: any;
  @Getter(types.GETTER_SUPER_PAY_APP_SHOW_OTHER_CONDITION)
  private superPayShowOtherCondition: any;
  @Getter(types.GETTER_SUPER_PAY_APP_CONFIG) private superPayAppConfig: any;
  @Getter(types.GETTER_SUPER_PAY_PARAMS) private superPayAppParams: any;
  @Prop({ default: "" })
  private value?: string;
  @Getter(types.GETTER_LOCALIZE_PRICE) private localizePrice: any;
  @Getter(types.GETTER_PRODUCTID_VALID) private product_id_valid: any;
  @Getter(types.GETTER_PRO_EXTRA_PERCENTAGE) private vipExtraPercentage: any;
  @Getter(types.GETTER_CAN_SHOW_VIP_NAV) private showVipNav: any;
  @Action(types.JUDGE_CAN_ENTER_PAYMENT) private judgePaymentMethodShow: any;
  @Getter(types.GETTER_SUPER_PAY_PAYMENT_SHOW_ENABLE)
  private superPayPayMentShowEnable: any;
  @Prop({
    default: () => {
      return null;
    }
  })
  private offer?: any;

  private selectWay: string = "paypal";
  private selectedPaypal: boolean = false;
  private selectedCard: boolean = false;
  private canShowStripe: boolean = false;
  private canShowPayPal: boolean = false;

  @Watch("selectWay", { immediate: true })
  private changeSelectWay(val: string, oldVal: string) {
    this.$emit("input", val);
    console.log("input:", {
      val,
      oldVal
    });
  }

  @Watch("value", { immediate: true })
  private changeValue(val: any, oldVal: any) {
    this.selectWay = val;
    console.log("value:", {
      val,
      oldVal
    });
  }

  private clickPay() {
    this.$emit("clickPay");
  }

  get localizedPrice() {
    return Localized.localizedPrice;
  }

  get isVip() {
    return GeneralUtilsHelper.isVip();
  }

  get superPayReducePirce() {
    // return this.localizedPrice(this.superPayInfoData.reduced_price);
    return numUtils.toDecimal2(this.superPayInfoData.reduced_price);
  }

  get paypalReducePirce() {
    return numUtils.toDecimal2(this.payPalInfoData.reduced_price);
  }

  get cardReducePirce() {
    return numUtils.toDecimal2(this.cardInfoData.reduced_price);
  }

  get iapReducePirce() {
    return numUtils.toDecimal2(this.iapInfoData.reduced_price);
  }

  get cardWayShow() {
    return this.paymentSwitch.stripe_enabled && !this.isSubsOffer;
  }

  get paypalWayShow() {
    return this.paymentSwitch.paypal_enabled;
  }

  get superPayDesc() {
    return this.isIos ? "Sponsored by App Store" : "Sponsored by Google Play";
  }

  get iapWayShow() {
    const product_id =
      this.offer && this.offer.iap && this.offer.iap.product_id;
    return product_id ? this.product_id_valid(product_id) : true;
  }

  get superPayWayShow() {
    return this.superPayPayMentShowEnable(this.offer);
  }

  get payWayShowCount() {
    //默认开启iap支付方式:
    let showCount: number = 1;
    if (this.canShowStripe) {
      showCount += 1;
    }
    if (this.canShowPayPal) {
      showCount += 1;
    }
    if (this.superPayWayShow) {
      showCount += 1;
    }
    return showCount;
  }

  get hideTatalCost() {
    //show item num >=4
    // return (
    //   this.paypalWayShow &&
    //   this.cardWayShow &&
    //   this.iapWayShow &&
    //   this.showVipNav(this.offer)
    // );

    return (
      (this.payWayShowCount === 3 && this.showVipNav(this.offer)) ||
      this.payWayShowCount >= 4
    );
  }

  get superPayBestTagShow() {
    return this.superPayWayShow;
  }

  get paypalBestTagShow() {
    return !this.superPayWayShow && this.paypalWayShow;
  }

  get cardBestTagShow() {
    return !this.superPayWayShow && !this.paypalWayShow && this.canShowStripe;
  }

  get iapBestTagShow() {
    return !this.superPayWayShow && !this.paypalWayShow && !this.canShowStripe;
  }

  get discountShow() {
    return this.infoData.discount === 0 ? false : true;
  }

  get selectWayText() {
    switch (this.selectWay) {
      case "paypal": {
        return "PayPal";
      }
      case "iap": {
        return this.isIos ? "App Store" : "Google Play";
      }
      case "card": {
        return "Card";
      }
      case "super_pay": {
        return this.isIos ? "App Store" : "Google Play";
      }
    }
  }

  get isIos() {
    return isIos();
  }

  get format() {
    return numUtils.format;
  }

  get totalCostText() {
    if (this.isIos && this.selectWay === "iap") {
      return this.localizePrice(this.offer.iap.product_id)
        ? `${
            this.localizePrice(this.offer.iap.product_id).localSymbol
          } ${numUtils.toDecimal2(
            this.localizePrice(this.offer.iap.product_id).price
          )}`
        : `$ ${this.infoData.total_price}`;
    } else {
      return `$ ${this.infoData.total_price}`;
    }
  }

  get infoData() {
    return this.infoByOffer(this.offer, this.selectWay);
  }
  get iapInfoData() {
    return this.infoByOffer(this.offer, "iap");
  }
  get payPalInfoData() {
    return this.infoByOffer(this.offer, "paypal");
  }
  get cardInfoData() {
    return this.infoByOffer(this.offer, "card");
  }
  get superPayInfoData() {
    return this.infoByOffer(this.offer, "super_pay");
  }

  get paypalRewardText() {
    return this.offer.kind.indexOf("vip") > -1
      ? this.payPalInfoData.reward_effect > 1
        ? "Months"
        : "Month"
      : this.payPalInfoData.type_name;
  }

  get iapRewardText() {
    return this.offer.kind.indexOf("vip") > -1
      ? this.iapInfoData.reward_effect > 1
        ? "Months"
        : "Month"
      : this.iapInfoData.type_name;
  }

  get cardRewardText() {
    return this.offer.kind.indexOf("vip") > -1
      ? this.cardInfoData.reward_effect > 1
        ? "Months"
        : "Month"
      : this.cardInfoData.type_name;
  }

  get superPayRewardText() {
    return this.offer.kind.indexOf("vip") > -1
      ? this.offer.effect > 1
        ? "Months"
        : "Month"
      : this.superPayInfoData.type_name;
  }

  get itemsRewardEffectTextShow() {
    return (
      this.infoData.reward_effect ||
      this.offer.kind === "lucky_coin" ||
      this.vipReward
    );
  }

  get buttonText() {
    if (
      this.offer.kind === "vip" &&
      this.offer.effect === 1 &&
      this.firstBuyAutoVip
    ) {
      return `TRY FOR FREE`;
    } else {
      return `PAY ${this.totalCostText}`;
    }

    //  else if (this.selectWay === "super_pay") {
    //   return `PAY ${this.localizedPrice(this.totalCostText)}`;
    // }
  }

  get totalEffect() {
    return this.infoData.effect + this.infoData.reward_effect;
  }

  // 临时屏蔽掉stripe的vip奖励
  get cardReward() {
    return this.selectWay === "card";
  }

  // 计算出vip额外的添加 规则： 比例*总额 向下取整
  get vipReward() {
    return this.isVip
      ? this.notShowVipReward
        ? 0
        : Math.floor(this.vipExtraPercentage * this.totalEffect * 0.01)
      : 0;
  }

  get notShowVipReward() {
    return (
      this.offer.kind.indexOf("coin") > -1 ||
      this.offer.kind.indexOf("subs") > -1 ||
      this.offer.kind.indexOf("vip") > -1
    );
  }

  get itemsEffectText() {
    if (this.offer.kind === "lucky_coin") {
      const { lucky_effect } = this.offer;
      return `Up to ${this.format(lucky_effect.max)}`;
    } else if (this.offer.kind.indexOf("vip") > -1) {
      return `VIP - ${this.format(this.totalEffect)} ${
        this.totalEffect > 1 ? "Months" : "Month"
      }`;
    } else if (this.offer.kind.indexOf("subs_like") > -1) {
      return (
        this.format(this.infoData.effect) +
        (this.infoData.effect > 1 ? " likes" : " like") +
        " on each new post"
      );
    } else if (this.offer.kind.indexOf("subs_follow") > -1) {
      return this.format(this.infoData.effect * 7) + " followers";
    } else {
      return `${this.format(this.totalEffect + this.vipReward)} ${
        this.infoData.type_name
      }`;
    }
  }

  get itemsRewardEffectText() {
    if (this.offer.kind === "lucky_coin") {
      const { lucky_effect } = this.offer;
      return `(*min ${this.format(lucky_effect.min)} coins guaranteed)`;
    } else if (this.offer.kind.indexOf("vip") > -1) {
      return `(+ ${this.infoData.reward_effect} Extra ${
        this.infoData.reward_effect > 1 ? "Months" : "Month"
      })`;
    } else {
      return `(+ ${this.format(
        this.infoData.reward_effect + this.vipReward
      )} Extra ${this.infoData.type_name})`;
    }
  }

  get paymentSwitch() {
    return GeneralUtilsHelper.paymentSwitch();
  }

  get isSubsOffer() {
    return GeneralUtilsHelper.isSubsOffer(this.offer);
  }

  get firstBuyAutoVip() {
    return !VipOfferUtils.boughtVip() && VipOfferUtils.isAutoRenew(this.offer);
  }

  private retainDialog(way: string) {
    this.dialogShow({
      title: "Don’t Miss Out",
      midContent: "Are you sure to give up the exclusive discount?",
      topIcon:
        way === "paypal"
          ? require("@/assets/icons-file/dialog/pic_dontmissout_paypal@3x.png")
          : require("@/assets/icons-file/dialog/pic_dontmissout_card@3x.png"),
      buttons: [
        {
          text: "I WANT DISCOUNT",
          clickFn: () => {
            way === "paypal"
              ? (this.selectedPaypal = true)
              : (this.selectedCard = true);
          }
        },
        {
          text: "GIVE UP",
          clickFn: () => {
            this.selectWay = "iap";
            way === "paypal"
              ? (this.selectedPaypal = true)
              : (this.selectedCard = true);
          }
        }
      ]
    });
  }

  private clickPaypalSelect() {
    this.selectWay = "paypal";
  }

  private clickIapSelect() {
    this.selectWay = "iap";
  }

  private clickCardSelect() {
    this.selectWay = "card";
  }

  private clickSuperPaySelect() {
    this.selectWay = "super_pay";
  }

  private beforeRouteEnter(to: any, from: any, next: any) {
    console.log("beforeRouteEnter");
    next();
  }

  private async mounted() {
    const enter_payment = await this.judgePaymentMethodShow(this.offer);
    this.canShowStripe = enter_payment.canShowStripe;
    this.canShowPayPal = enter_payment.canShowPayPal;
    const back = this.$route.params.type;
    // 如果是从stripe返回，则不执行下面的逻辑
    !back && (this.selectWay = this.canShowPayPal ? "paypal" : "card");

    //如果superpay能够显示，默认的支付方式为super_pay:
    if (this.superPayWayShow) {
      this.selectWay = "super_pay";
    }
  }
}
